<script setup lang="ts">

  const props = defineProps({
    text: null,
    link: null,
    required: null,
    value: {
      type: null,
      required: true,
      default: false
    },
    validate: null,
    clientIp: null,
    index: null
  })

  const emit = defineEmits({
    change: null
  })
  const vModel = ref<boolean>(false)

  function change() {
    emit('change', vModel.value, props.index)
  }
</script>

<template>
  <div class="flex gap-1">
    <input
        type="checkbox"
        :value="value"
        v-model="vModel"
        class="accent-ui cursor-pointer"
        @change="change"
    >
    <a
        v-if="link"
        :href="link"
        :target="link ? '_blank' : '_self'"
        :class="['text-[9.5px] lg:text-[16px] cursor-pointer underline', validate ? 'text-red-500' : 'text-sky-600']"
    >
      {{text}}
    </a>
    <button
        v-else
        type="button"
        class="text-[9.5px] lg:text-[16px] cursor-pointer"
        :class="[validate ? 'text-red-500' : 'text-dark']"
    >
      {{text}}
    </button>
  </div>
</template>
